import { Tag, theme } from 'antd';
import DashBoardCCView from '../components/dashboard/DashBoardCCView';
import DashBoardMapCC from '../components/dashboard/DashBoardMapCC';
import { useUserContext } from '../hooks/UserSettingProvider';
import URLTabs from '../components/common/URLTabs';

export default function DashboardTabCcView() {
  const { user } = useUserContext();
  const { token: { colorPrimary } } = theme.useToken();

  return (
    <URLTabs
      size='large'
      defaultActiveKey='#dashboard'
      items={[
        {
          key: "#dashboard", 
          label: <span>Dashboard</span>, 
          children: <DashBoardCCView id={user.cc ? user.cc : null }/>
        },
        {
          key: "#map", 
          label: <span>Map</span>,
          children: <DashBoardMapCC id={user.cc ? user.cc : null }/> 
        },
      ]}
      tabBarExtraContent={
        <Tag 
          color={colorPrimary} 
          style={{fontSize: 16, fontWeight: "bold", padding:8,}}>
            {user ? user.display_name : "Unknown"}
        </Tag>
      }/> 
  )
}
